{
  "invite": {
    "title": "確認邀請",
    "previewHeading": "你收到「{{team}}」的組隊邀請",
    "checking": "正在確認邀請…",
    "checkFailed": "無法確認此邀請。",
    "competitionLabel": "競賽：{{name}}",
    "inviterLabel": "邀請者：{{name}}",
    "inviterLabelUnknown": "邀請者：不明",
    "teamLabel": "團隊：{{name}}",
    "memberCount": "目前成員：{{count}} / {{max}}",
    "joinNotice": "加入後，你會成為這個團隊的成員。",
    "declineForNow": "暫時不加入",
    "checkingSignIn": "正在確認您的登入狀態…",
    "joining": "加入團隊中…",
    "accept": "接受邀請並加入",
    "verifyRequired": "請先完成人機驗證，再接受邀請。",
    "signInFirst": "登入後接受邀請",
    "createAccountFirst": "建立帳號後接受邀請",
    "acceptFailed": "無法接受此邀請。",
    "goToDashboard": "前往我的競賽",
    "expired": {
      "title": "這個邀請連結已過期",
      "description": "請向團隊隊長索取新的邀請連結。"
    },
    "invalidGeneric": {
      "title": "這個邀請已失效",
      "description": "請向團隊隊長確認是否有新的邀請。"
    },
    "alreadyInOtherTeam": {
      "title": "你已加入這場競賽的另一個團隊",
      "description": "一場競賽只能加入一個團隊。",
      "viewCurrentTeam": "查看目前團隊"
    },
    "alreadyMember": {
      "title": "你已經是這個團隊的成員",
      "description": "不需要重新加入，可以直接前往競賽查看團隊狀態。"
    },
    "teamFull": {
      "title": "這個團隊目前已額滿",
      "description": "你可以聯絡團隊隊長確認後續安排。"
    },
    "success": {
      "title": "已加入 {{team}}",
      "memberNotice": "你現在是這個團隊的成員。",
      "cta": "進入競賽",
      "viewTeam": "查看團隊"
    }
  }
}
